import { Button } from "antd";
import React from "react";
import CustomPopconfirm from "../Popover/CustomPopconfirm";
import scrollToFieldIfVisible from "../../utils/scrollToFieldIfVisible";

interface FormBuilderPopconfirmSubmitButtonProps {
	form: any;
	labelText: string;
	title: React.ReactNode;
	onConfirm: () => void | Promise<void>;
	isLoading?: boolean;
	onValidationError?: (error: unknown) => void;
}

const FormBuilderPopconfirmSubmitButton = ({
	form,
	labelText,
	title,
	onConfirm,
	isLoading,
	onValidationError,
}: FormBuilderPopconfirmSubmitButtonProps) => {
	const handleConfirm = async () => {
		try {
			await form.formRef.validateFields();
			await onConfirm();
		} catch (error: any) {
			if (error?.errorFields?.length > 0) {
				const firstError = error.errorFields[0];
				const fieldName = Array.isArray(firstError.name)
					? firstError.name
					: [firstError.name];

				scrollToFieldIfVisible(form.formRef, fieldName, {
					behavior: "smooth",
					block: "center",
				});

				const fieldElement = document.querySelector(
					`[name="${fieldName.join(".")}"], [id="${fieldName.join(".")}"]`
				);
				if (fieldElement) {
					fieldElement.classList.add("custom-field-error");
					setTimeout(() => {
						fieldElement.classList.remove("custom-field-error");
					}, 3000);
				}
			}
			if (onValidationError) {
				onValidationError(error);
			}
		}
	};

	return (
		<CustomPopconfirm title={title} handleConfirm={handleConfirm}>
			<Button type="primary" htmlType="button" disabled={isLoading}>
				{labelText}
			</Button>
		</CustomPopconfirm>
	);
};

export default FormBuilderPopconfirmSubmitButton;
